module.exports = __webpack_public_path__ + "img/icone-exterior.812fdf85.svg";